// removed by extract-text-webpack-plugin
module.exports = {"seemore":"seemore___3uU-3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SeeMoreItems/SeeMoreItems.scss
// module id = W5uo
// module chunks = 57